// removed by extract-text-webpack-plugin
module.exports = {"overlay":"theme__overlay__SOtrtAJF","active":"theme__active__112FibQ5"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-toolbox/lib/overlay/theme.css
// module id = 954
// module chunks = 0